import styles from "./style.module.scss";

interface BrandBadgeProps {
    label: string;
    selected: boolean;
    onClick: () => void;
    disabled?: boolean;
}

const BrandBadge = ({ label, selected, onClick, disabled = false }: BrandBadgeProps) => {
    return (
        <div
            className={`${styles["brand-badge"]} ${selected ? styles["selected"] : ""} ${
                disabled ? styles["disabled"] : ""
            }`}
            onClick={disabled ? undefined : onClick}
            role="button"
            tabIndex={disabled ? -1 : 0}
            onKeyDown={(e) => {
                if (!disabled && (e.key === "Enter" || e.key === " ")) {
                    e.preventDefault();
                    onClick();
                }
            }}
        >
            {label}
        </div>
    );
};

export default BrandBadge;
